<div *ngIf="isOpen" class="modal fade show d-block">
  <div class="modal-dialog modal-lg">
    <div class="modal-content popup-container">
      <div class="modal-body pt-2">
        <div class="row m-0">
          <div class="col-md-11">
            <div class="row pop-up-pageTitle"> Select opportunity and opportunity service</div>
            <div class="row d-flex alignment">
              <div class="pl-0">
                <span class="selectedclientName">{{selectedChangeOrderClient.clientName}}</span>
              </div>
              <div class="circle"></div>
              <div>
                <span class="selectedclientName">{{selectedChangeOrderClient.engagementName}}</span>
              </div>
              <div class="circle"></div>
              <div>
                <span class="selectedclientName">{{selectedChangeOrderClient.solutionCode}}</span>
              </div>
            </div>
          </div>

          <div class="col-md-1 p-0">
            <button type="button" class="close edp-font-14" data-dismiss="modal" aria-hidden="true"
              (click)="onClose();">
              <span class="close-text mr-1">Close </span>
              <span class="modal-close-btn">&times;</span>
            </button>
          </div>
        </div>

        <p class="popup-description mb-2 mt-3 pt-1">
          Select the opportunity service(s) to
          associate with this assignment.          
        </p>

        <div class="table-box mb-2 pb-2">
          <div class="col-md-12 px-0">
            <div class="main-table tableOneViewInitiate">
              <table class="table table-engage mb-0">
                <thead>
                  <tr>
                    <th class="thHeadTwo">Opportunity</th>
                    <th class="thHeadThree">Opportunity Service</th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let item of assignmentSelections; let i=index">
                    <!-- Opportunity -->
                    <td class="thHeadTwo">
                      <div class="selectdiv">

                        <ng-container
                          *ngIf = "item.availableOpportunities.length > 0;
                                    else noOpportunity">
                                  
                        <select class="form-control dropdown rounded-0" 
                          [(ngModel)]="item.selectedOpportunityId"
                          (change)="onOpportunityChange(item)" [disabled]="!item.isSelected">
                          <option value="">Select opportunity...</option>

                          <option *ngFor="let opp of item.availableOpportunities" [value]="opp.opportunityId">
                            {{opp.opportunityName}}</option>
                        </select>
                      
                        </ng-container>
                        <ng-template #noOpportunity>
                          <select class="form-control dropdown rounded-0" disabled>
                            <option>No tracked opportunities for {{item.solutionCode}}</option>
                          </select>
                        </ng-template>

                      </div>
                    </td>

                    <!-- Opportunity Service -->
                    <td class="thHeadThree">
                      <div class="selectdiv">
                        <select class="form-control dropdown rounded-0" 
                          [(ngModel)]="item.selectedOpportunityServiceId"
                          (change)="onServiceChange(item)" [disabled]="!item.isSelected ||
                                                                       !item.selectedOpportunityId ||
                                                                       !item.availableOpportunities || 
                                                                        item.availableOpportunities.length === 0 ||
                                                                        item.availableServices.length === 0">

                         <option value="">{{ item.selectedOpportunityId 
                                                ? 'Select opportunity service...' 
                                                : 'Select an opportunity first...'}}</option>                                                  

                          <option *ngFor="let service of item.availableServices" [value]="service.opportunityServiceId">
                            {{service.solutionCode}} - {{service.opportunityServiceId}}</option>
                        </select>
                      </div>
                    </td>

                  </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>

        <div class="no-record border mt-2">
          <div class="row w-100 oneViewNoResult p-3">
            <div class="col-md-12 text-left ml-3 bgColorOpp">
              <p class="pt-2">
                If you can't find the right opportunity or opportunity service, it may not yet be created in
                oneView.
                Contact your engagement partner, principal or managing director for next steps.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <div *ngIf="validationMessage" class="text-danger mt-2" style="margin-left: 15px;">
          <span> {{validationMessage}}</span>
        </div>

        <button type="button" class="SecondaryButton mr-2 Btn150" data-dismiss="modal" id="btnCancelOpportunityNew"
          (click)="onClose();">
          <span class="d-inline-block mr-1 align-top">
            <img alt="OK" src="../../../../assets/images/EDP/MessageDialog/cancel-blue.svg">
          </span>
          <span class="d-inline-block align-middle">Cancel</span>
        </button>
        <button type="button" class="PrimaryButton Btn150" id="btnOkOpportunityNew" (click)="onConfirm();">
          <span class="d-inline-block mr-1 align-top">
            <img alt="OK" src="../../../../assets/images/EDP/MessageDialog/delete-white.svg">
          </span>
          <span class="d-inline-block align-middle">OK</span>
        </button>
      </div>

    </div>

  </div>
</div>
<div *ngIf="isOpen" class="modal-backdrop fade show"></div>